// extracted by mini-css-extract-plugin
export default {"pageRoot":"offboard-l1-detail-page_pageRoot__vZPH0"};